/**
 * MIT License
 *
 * Copyright (c) 2022 Brendan C. Ward, Astute Spruce, LLC
 * Changes copyright (c) 2022 University of Washington

 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:

 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.

 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

import React from 'react'
import PropTypes from 'prop-types'
import { ExternalLinkAlt } from '@emotion-icons/fa-solid'
import { Flex, Box } from 'theme-ui'

import OutboundLink from './OutboundLink'

const ExternalLink = ({ to, children, sx }) => (
  <OutboundLink to={to} sx={sx}>
    <Flex sx={{ gap: '0.5rem' }}>
      <ExternalLinkAlt
        size="1em"
        style={{
          margin: '0.15em 0 0 0',
          flex: '0 0 auto',
          opacity: 0.5,
        }}
      />
      <Box>{children}</Box>
    </Flex>
  </OutboundLink>
)

ExternalLink.propTypes = {
  to: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.Node),
  ]).isRequired,
  sx: PropTypes.object,
}

ExternalLink.defaultProps = {
  sx: {},
}

export default ExternalLink
